<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="650px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <div class="row">
              <div class="col-md-4">
                <v-text-field
                  data-vv-as="Código"
                  label="Código*"
                  name="code"
                  v-model="item.code"
                  v-validate="'required'"
                  :disabled="isViewModal()"
                ></v-text-field>
                <span class="red--text">{{ errors.first("code") }}</span>
              </div>

              <div class="col-md-8">
                <v-text-field
                  data-vv-as="Nombre"
                  label="Nombre*"
                  name="name"
                  v-model="item.name"
                  v-validate="'required'"
                  :disabled="isViewModal()"
                ></v-text-field>
                <span class="red--text">{{ errors.first("name") }}</span>
              </div>

              <div class="col-md-12">
                <v-combobox
                  v-model="item.tipo_comprobante"
                  data-vv-as="tipo_comprobante"
                  name="tipo_comprobante"
                  item-text="name"
                  item-value="id"
                  :items="tipos_comprobante"
                  label="Tipo de Comprobante*"
                  autocomplete="off"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text">{{ errors.first("tipo_comprobante") }}</span>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import { generalService } from "@/libs/ws/generalService";

export default {
  mixins: [ModalGenericMixin],
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      tipos_comprobante: [],
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  mounted() {
    this.loadComboData();
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    loadComboData() {
      generalService.setSection(Constant.SECTION_TESORERIA_TIPO_COMPROBANTE);
      generalService.filter().then((r) => { this.tipos_comprobante = r.result; }).catch(() => {});
    },
    createItem(e) {
      this.$validator.validate().then((valid) => {
        if (valid) {
          e.preventDefault();
          this.loading = true;
          const data = {
            id:                   this.item.id,
            code:                 this.item.code,
            name:                 this.item.name,
            tipo_comprobante:     this.item.tipo_comprobante ? { id: this.item.tipo_comprobante.id } : null,
          };

          const request = this.item.id > 0 ? this.service.update(data) : this.service.create(data);
          request
            .then((r) => {
              if (r.status) {
                this.$emit("loadList");
                this.$emit("updateDialog", false);
              } else {
                alert(r.msg);
              }
            })
            .catch(() => { alert("Error al guardar."); })
            .finally(() => { this.loading = false; });
        }
      });
    },
  },
};
</script>
